import * as yup from 'yup'

export const maskedInput = yup.object().shape({
  display: yup.string(),
  value: yup.string(),
})
